import React, { Component } from "react";
import classnames from "classnames";

import style from "./style.css";

export default class Loader extends Component {
  render() {
    let componentStyle;
    switch (this.props.style) {
      case LoaderStyle.ORANGE:
        componentStyle = style.orange;
        break;
      case LoaderStyle.WHITE:
        componentStyle = style.white;
        break;
      default:
        componentStyle = style.orange;
        break;
    }

    const finalClassName = classnames(style.root, this.props.rootClassname, componentStyle);
    return (
      <div className={finalClassName}>
        <div className={style.rect_1} />
        <div className={style.rect_2} />
        <div className={style.rect_3} />
        <div className={style.rect_4} />
        <div className={style.rect_5} />
      </div>
    );
  }
}

export const LoaderStyle = {
  ORANGE: "ORANGE",
  WHITE: "WHITE",
};



// WEBPACK FOOTER //
// ./src/components/Loader/index.js